import React from 'react';
import { withTranslation } from 'react-i18next';
import CustomRegistration from '../CustomRegistration';
import { getPaymentMethodsQuery, getSubscriptionsQuery } from './query';
import { showMessage } from '../../helpers/showMessage';

class ChangePlanCustom extends React.Component {
    constructor() {
        super();

        this.updateBillingInfo = this.updateBillingInfo.bind(this);
        this.getPaymentMethods = this.getPaymentMethods.bind(this);
        this.getSubscription = this.getSubscription.bind(this);

        this.ref = React.createRef(false);

        this.urlParams = new URLSearchParams(window.location.search);

        this.isCancel = this.urlParams.get('cancellation');
        // Reactivation CTAs (settings / header / inactive-subscription banners) link here with
        // ?reactivation=true: the user is restoring a cancelled plan, so the add-ons step is hidden.
        this.isReactivation = this.urlParams.get('reactivation') === 'true';

        if (this.isCancel) {
            setTimeout(() => {
                const cancelationElement = document.getElementById('change-plan-cancelation');
                if (cancelationElement) {
                    cancelationElement.scrollIntoView({ behavior: 'smooth' });
                }
            }, 500);
        }

        this.state = {
            billingInfo: null,
            subscriptions: null,
            defaultData: {},
            defaultInterval: null,
            defaultPromotionCode: null,
            loading: false,
            payment_methods: [],
        };
    }

    async getSubscription() {
        try {
            this.setState({ loading: true });
            const subscriptionsResponse = await getSubscriptionsQuery();
            const data = await subscriptionsResponse.json();
            if (subscriptionsResponse.ok) {
                this.setState({ subscriptions: data, loading: false });
            } else {
                showMessage(data.detail || 'Error fetching subscription information.', 'error');
                this.setState({ loading: false });
            }
        } catch (err) {
            showMessage(err?.message || 'Error fetching subscription information.', 'error');
            console.log(err);
            this.setState({ loading: false });
        }
    }

    async getPaymentMethods() {
        try {
            this.setState({ loading: true });
            const response = await getPaymentMethodsQuery();
            const data = await response.json();

            if (response.ok) {
                this.setState({ payment_methods: data?.payment_methods, loading: false });
            } else {
                showMessage(data.detail || 'Error fetching payment methods.', 'error');
                this.setState({ loading: false });
            }
        } catch (err) {
            showMessage(err?.message || 'Error fetching payment methods.', 'error');
            console.log(err);
            this.setState({ loading: false });
        }
    }

    async componentDidMount() {
        try {
            this.getSubscription();
            this.getPaymentMethods();
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.billingInfo && this.state.subscriptions && !this.ref.current) {
            this.ref.current = true;
            const defaultData = {};
            for (let key in this.state.billingInfo) {
                const item = this.state.billingInfo[key];
                if (!item) continue;

                const data = this.state.subscriptions?.items?.find(
                    (sub) => sub.product_id === item.product_id,
                );
                if (data) {
                    defaultData[key] = {
                        ...data,
                    };
                }
            }

            const interval = this.state.subscriptions?.subscription_interval;
            const promotion_code = this.state.subscriptions?.promotion_code;

            this.setState({
                defaultData,
                defaultInterval: interval,
                promotionCode: promotion_code,
            });
        }
    }

    updateBillingInfo(info) {
        this.setState({ billingInfo: info });
    }

    render() {
        return (
            <div className="custom-plan-wrapper">
                <CustomRegistration
                    isEdit
                    inactiveProduct={this.props.inactiveProduct}
                    isCancel={Boolean(this.isCancel)}
                    isReactivation={this.isReactivation}
                    updateBillingInfo={this.updateBillingInfo}
                    defaultData={this.state.defaultData}
                    defaultInterval={this.state.defaultInterval}
                    parentLoading={this.state.loading}
                    payment_methods={this.state.payment_methods}
                    defaultPromotionCode={this.state.promotionCode}
                />
            </div>
        );
    }
}

export default withTranslation()(ChangePlanCustom);
